<template>
  <section>
    <div class="container pt-4 pb-5">
      <SectionContainer class="text-center">
        <PrimarySectionTitle>
          <h2>Recuperação de senha</h2>
        </PrimarySectionTitle>

        <div class="row justify-content-center">
          <div class="col-md-5 text-left">
            <AlertBox
              v-if="!!message.message.length"
              :type="message.type"
            >{{ message.message }}</AlertBox>

            <form
              @submit.prevent="submit"
              v-if="!success"
            >
              <PrimaryInput
                v-model="form.email"
                type="email"
                :validation="$v.form.email"
                placeholder="E-mail"
                :required="true"
              />

              <PrimaryInput
                v-model="form.password"
                type="password"
                :validation="$v.form.password"
                placeholder="Nova senha"
                :required="true"
              />

              <PrimaryInput
                v-model="form.password_confirmation"
                type="password"
                :validation="$v.form.password_confirmation"
                placeholder="Confirme nova senha"
                :required="true"
              />
              
              <PrimaryButton
                class="mt-3"
                type="submit"
                :full="true"
                :disabled="$v.form.$invalid"
              >
                <span>TROCAR SENHA</span>
              </PrimaryButton>
            </form>
          </div>
        </div>
      </SectionContainer>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import SectionContainer from '@/components/layout/SectionContainer'
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import PrimaryButton from '@/components/buttons/PrimaryButton'
  import AlertBox from '@/components/layout/AlertBox'
  import classValidationChecker from '@/utils/classValidationChecker'
  import authResetPasswordRules from '@/validations/auth/authResetPasswordRules'
  import PrimaryInput from '@/components/form/PrimaryInput'

  export default {
    components: {
      SectionContainer,
      PrimarySectionTitle,
      PrimaryButton,
      AlertBox,
      PrimaryInput,
    },

    validations: {form: authResetPasswordRules},

    metaInfo () {
      return {
        title: 'Recuperação de Senha | CyberClass'
      }
    },

    data: () => ({
      success: false,

      message: {
        type: '',
        message: ''
      },

      form: {
        email: '',
        password: '',
        password_confirmation: '',
      }
    }),

    computed: {
      token () {
        return this.$route.params.token
      },
    },

    methods: {
      ...mapMutations('app', ['setLoading']),

      ...mapActions('auth', ['changePasswordByReset']),

      async submit () {
        const form = this.form

        form.token = this.token

        try {
          this.setLoading(true)

          const response = await this.changePasswordByReset(form)

          this.success = true
          this.message.type = 'info'
          this.message.message = response.data.message
          this.setLoading(false)
        } catch (err) {
          this.message.type = 'danger'
          this.message.message = err.data.message
          this.form.password = this.form.password_confirmation = ''
          this.setLoading(false)
        }
      },

      classValidation (field) {
        return classValidationChecker(this.$v.form[field])
      }
    }
  }
</script>
